module.exports = __webpack_public_path__ + "static/img/tip.0dd595b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qcwy/images/tip.png
// module id = 7fXk
// module chunks = 1